// 初始设置
setMenuColors();

// 监听窗口大小变化
window.addEventListener('resize', debounce(setMenuColors, 250));

// 监听菜单点击
document.addEventListener('click', e => {
  if (e.target.closest('.menu-drawer__toggle') || e.target.closest('.menu-drawer__item')) {
    setTimeout(colorSaleInMobileMenu, 50);
  }
});

// 防抖函数，避免频繁触发
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

function setMenuColors() {
  if (window.innerWidth > 1025) {
    // 桌面端颜色设置
    document.querySelectorAll('span.flex.items-center.font-navigation.menu__item-text.reversed-link')
      .forEach(span => {
        const text = span.textContent.trim().toLowerCase();
        if (text === 'sale') {
          span.style.color = 'var(--color-badge-sale)';
          const svg = span.querySelector('svg');
          if (svg) svg.style.stroke = 'var(--color-badge-sale)';
        }
      });
    
    // 为 Gift Ideas 和 Outlet Store 设置颜色
    document.querySelectorAll('.menu__item .reversed-link')
      .forEach(span => {
        const text = span.textContent.trim().toLowerCase();
        if (text === 'gift ideas' || text === 'outlet store') {
          span.style.color = 'var(--color-badge-sale)';
        }
      });
  } else {
    // 移动端颜色设置
    colorSaleInMobileMenu();
  }
}

function colorSaleInMobileMenu() {
  // 移动端 Sale 链接颜色设置
  document.querySelectorAll('.menu-drawer__item summary span.flex.items-center')
    .forEach(span => {
      if (span.textContent.trim().toLowerCase() === 'sale') {
        span.style.color = 'var(--color-badge-sale)';
        const summary = span.closest('summary');
        if (summary) {
          const svg = summary.querySelector('svg');
          if (svg) svg.style.color = 'var(--color-badge-sale)';
        }
      }
    });
  
  // 移动端 Gift Ideas 和 Outlet Store 链接颜色设置
  document.querySelectorAll('.menu-drawer__item .reversed-link, .menu-drawer__item a')
    .forEach(element => {
      const text = element.textContent.trim().toLowerCase();
      if (text === 'gift ideas' || text === 'outlet store') {
        element.style.color = 'var(--color-badge-sale)';
      }
    });
  
  document.querySelectorAll('.menu-drawer__item-back-link')
    .forEach(btn => {
      if (btn.textContent.trim().toLowerCase() === 'sale') {
        btn.style.color = 'var(--color-badge-sale)';
        const svg = btn.querySelector('svg');
        if (svg) svg.style.color = 'var(--color-badge-sale)';
      }
    });
}